import { Link } from "react-router-dom";
import { MapPin, Instagram } from "lucide-react";
import { CLINIC, NAV_LINKS, HOURS } from "@/lib/site";
import { BookButton } from "@/components/bits";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-olive text-sand">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <img src="/assets/logo-light.png" alt="Actus Osteopati" className="h-14 md:h-16 w-auto" />
            <p className="mt-6 text-sand/70 text-sm leading-relaxed max-w-xs">
              Osteopatiklinikk i Oslo sentrum. Helhetlig undersøkelse og
              behandling av muskel- og skjelettplager.
            </p>
            <div className="mt-8">
              <BookButton testId="footer-book-button" label="Book time" />
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.3em] uppercase text-sand/50 mb-6">Navigasjon</p>
            <nav className="flex flex-col gap-3">
              {NAV_LINKS.map((l) => (
                <Link
                  key={l.to}
                  data-testid={`footer-link-${l.to.slice(1)}`}
                  to={l.to}
                  className="text-sm text-sand/80 hover:text-sand transition-colors duration-300"
                >
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase text-sand/50 mb-6">Besøksadresse</p>
            <p className="flex items-start gap-3 text-sm text-sand/80 leading-relaxed">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>
                {CLINIC.name}
                <br />
                {CLINIC.address}, 7. etasje
                <br />
                {CLINIC.city}
              </span>
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.3em] uppercase text-sand/50 mb-6">Åpningstider</p>
            <div data-testid="footer-hours" className="flex flex-col gap-2">
              {HOURS.map(([day, time]) => (
                <p key={day} className="flex justify-between gap-6 text-sm text-sand/80 max-w-[13rem]">
                  <span>{day}</span>
                  <span>{time}</span>
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sand/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-xs text-sand/50">© 2026 Actus Osteopati. Alle rettigheter forbeholdt.</p>
          <div className="flex items-center gap-6">
            <a
              data-testid="footer-instagram-link"
              href="https://www.instagram.com/actusosteopati"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-xs text-sand/50 hover:text-sand transition-colors duration-300"
            >
              <Instagram size={14} />
              Følg oss på Instagram
            </a>
            <Link data-testid="footer-link-personvern" to="/personvern" className="text-xs text-sand/50 hover:text-sand/80 transition-colors duration-300">
              Personvern
            </Link>
            <p className="text-xs text-sand/50">Osteopat i Oslo sentrum</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
